<div class="container mx-auto md:px-20px py-mobile-spacing sm:py-default-spacing">
  <div class="content grid gap-x-4px px-24px sm:px-72px py-72px sm:rounded-default">
    <div class="grid grid-cols-12 gap-y-72px">
      <video src="assets/videos/contact-form-bg.mp4" [muted]="true" [autoplay]="true" playsInline loop
        onloadedmetadata="this.muted=true"></video>
      <div class="headline-wrapper col-span-12 lg:col-span-6 justify-center">
        <span>{{ 'CONTACT_FORM.HEADLINE' | translate }}</span>
      </div>
      <div class="selector-wrapper col-span-12 lg:col-span-6">
        <app-horizontal-selector [data]="['CONTACT_FORM.FIELD_OF_INTEREST.PLACEHOLDER' | translate, 'CONTACT_FORM.FIELD_OF_INTEREST.REAGENTS' | translate, 'CONTACT_FORM.FIELD_OF_INTEREST.PRODUCTS' | translate, 'CONTACT_FORM.FIELD_OF_INTEREST.GENERAL' | translate]"
          [placeholder]="'CONTACT_FORM.FIELD_OF_INTEREST.PLACEHOLDER' | translate" (setExpanded)="setExpanded($event)"
          (selectedChange)="selectedCategory = $event"></app-horizontal-selector>
      </div>
    </div>
    <app-contact-form-content class="contact-form" [class.expand]="expanded"
      [category]="selectedCategory"></app-contact-form-content>
  </div>
</div>
